// «¿Con qué autoescuela trabajas?» (21/10/2026): solo en el alta del Plan Profesor (?plan=profesor).
// OPCIONAL: vacío no frena el alta. Viaja en TODAS las llamadas a /public/signup/start como
// `autoescuela_trabajo` (texto) o `autoescuela_por_su_cuenta: true` («Por mi cuenta, sin autoescuela»).
// a_publicSignupStart lo vuelve a sanear (≤ 120) y a_publicSignupVerify lo deja en c_empresas
// (`profesor_autoescuela` / `profesor_por_su_cuenta`); sale en los avisos de Telegram de David.
// Ficha: docs/features/autoescuela-plan-profesor.md
export const AUTOESCUELA_TRABAJO_MAX = 120;

export const PROFESOR_AUTOESCUELA_TEXT = {
  es: {
    label: "¿Con qué autoescuela trabajas?",
    optional: "(opcional)",
    placeholder: "Autoescuela y ciudad",
    porSuCuenta: "Por mi cuenta, sin autoescuela",
  },
  // Catalán central (alta con ?lang=ca, utils/altaIdioma.js): mismo texto que el valenciano.
  ca: {
    label: "Amb quina autoescola treballes?",
    optional: "(opcional)",
    placeholder: "Autoescola i ciutat",
    porSuCuenta: "Pel meu compte, sense autoescola",
  },
  va: {
    label: "Amb quina autoescola treballes?",
    optional: "(opcional)",
    placeholder: "Autoescola i ciutat",
    porSuCuenta: "Pel meu compte, sense autoescola",
  },
  en: {
    label: "Which driving school do you work with?",
    optional: "(optional)",
    placeholder: "Driving school and city",
    porSuCuenta: "On my own, no driving school",
  },
};

/**
 * Campos para el POST (se esparcen en el cuerpo). Sin plan profesor o sin respuesta → {} (el cuerpo
 * no cambia: JSON omite lo que no está).
 */
export function profesorAutoescuelaPayload(planProfesor, texto, porSuCuenta) {
  if (!planProfesor) return {};
  if (porSuCuenta === true) return { autoescuela_por_su_cuenta: true };
  if (typeof texto !== "string") return {};
  const s = texto.replace(/\s+/g, " ").trim().slice(0, AUTOESCUELA_TRABAJO_MAX).trim();
  return s ? { autoescuela_trabajo: s } : {};
}
